import { Injectable } from '@angular/core';
import {
  AbstractControlOptions,
  UntypedFormArray,
  Validators,
} from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import {
  FinancialKnowledge,
  ProfilEmprunteurSportDeplacements,
} from '@app/forms/subscription/definition/interface/subscription';
import FormGroupArray from '@app/forms/subscription/services/FormGroupArray';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  generateForm(
    entity: ProfilEmprunteurSportDeplacements & {
      profilEmprunteur: any;
    },
    option,
  ) {
    let options: AbstractControlOptions = {};
    return this.formBuilder.group(
      {
        ownerId: [entity.ownerId],
        userFirstName: [entity.userFirstName],
        userLastName: [entity.userLastName],
        profilEmprunteur: this.formBuilder.group({
          sportARisque: [
            _.isBoolean(entity?.profilEmprunteur?.sportARisque)
              ? entity?.profilEmprunteur?.sportARisque
              : null,
            Validators.required,
          ],
          deplacementsProfessionnelsOuHumanitairesEtranger: [
            _.isBoolean(
              entity?.profilEmprunteur
                ?.deplacementsProfessionnelsOuHumanitairesEtranger,
            )
              ? entity?.profilEmprunteur
                  ?.deplacementsProfessionnelsOuHumanitairesEtranger
              : null,
            Validators.required,
          ],
        }),
      },
      options,
    );
  }
  generate(entity: any[], option) {
    return FormGroupArray.generate({
      entity,
      options: option,
      formBuilder: this.formBuilder,
      generateForm: this.generateForm.bind(this),
    });
  }
  get owners() {
    return this.form.get('owners') as UntypedFormArray;
  }

  extract() {
    return this.form.value.owners;
  }
}
